import { TridentSkeleton, HostEnvironment } from '@mondaydotcomorg/trident-skeleton';

export const SKELETON_KEY = Symbol.for('trident.skeleton');

console.log('NODE_ENV', process.env.NODE_ENV);

export function initSkeleton() {
  if (window[SKELETON_KEY]) {
    return;
  }

  const isProduction = process.env.NODE_ENV === 'production';

  window[SKELETON_KEY] = new TridentSkeleton({
    api: {} as any,
    // isDev: typeof __DEVELOPMENT__ !== "undefined",
    preloadedMFs: {},
    // allMfData: window.microfrontends.allMfData,
    mfUrl: 'https://microfrontends.monday.com',
    host: {
      name: 'magic',
      environment: isProduction ? HostEnvironment.production : HostEnvironment.development,
    },
    // onEvent,
    isAssetsFlattened: true,
  });

  return window[SKELETON_KEY];
}

export function getMFSkeleton() {
  const result: TridentSkeleton = window[SKELETON_KEY];
  if (!result) {
    throw new Error('Skeleton not initialized');
  }
  return result;
}
